var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgS = function SvgS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.695 17.195a1.2 1.2 0 0 1-.605-.168l-5.506-3.27C1.93 12.776.745 11.188.25 9.287A7.52 7.52 0 0 1 .957 3.69C2.924.17 7.304-1.046 10.72.982l5.505 3.27c.582.346.782 1.112.447 1.712s-1.079.806-1.66.46l-5.506-3.27c-2.254-1.338-5.144-.536-6.442 1.788-1.298 2.325-.52 5.305 1.734 6.643l5.505 3.27c.582.345.782 1.112.447 1.712a1.21 1.21 0 0 1-1.055.628",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.837 24a6.94 6.94 0 0 1-3.556-.986l-5.506-3.27a1.275 1.275 0 0 1-.447-1.712 1.195 1.195 0 0 1 1.66-.46l5.506 3.269a4.56 4.56 0 0 0 3.58.482 4.7 4.7 0 0 0 2.862-2.27 4.96 4.96 0 0 0 .468-3.691 4.82 4.82 0 0 0-2.201-2.952L7.697 9.14a1.275 1.275 0 0 1-.446-1.711 1.196 1.196 0 0 1 1.66-.461l5.505 3.27c1.655.982 2.84 2.57 3.336 4.472a7.52 7.52 0 0 1-.709 5.594c-.953 1.707-2.493 2.928-4.337 3.44a7 7 0 0 1-1.87.256",
    clipRule: "evenodd"
  })));
};
export default SvgS;